import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, ButtonProps, useTheme } from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import { SmallIconButton } from '../common';

interface ActionButtonsProps {
    isFinished?: boolean;
    onDelete?: () => void;
    proceedLink: {
        pathname: string;
        state: { referrer: string };
    };
}

const LinkButton = (props: ButtonProps<RouterLink>) => (
    <Button
        variant='outlined'
        component={RouterLink}
        {...props}
    />
);

const ActionButtons = ({ isFinished, proceedLink, onDelete }: ActionButtonsProps) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const deleteTooltipTitle = t('Delete');

    let leftActions: React.ReactNode = null;
    if (isFinished) {
        const backgroundColor = theme.palette.success.light;
        const color = theme.palette.success.main;

        const buttonProps: ButtonProps<RouterLink> = {
            to: proceedLink,
            style: { color, backgroundColor, borderColor: backgroundColor },
        };

        leftActions = (
            <LinkButton {...buttonProps}>
                {t('Proceed')}
            </LinkButton>
        );
    }

    return (
        <Box display='flex' alignItems='center'>
            {leftActions}
            <Box flexGrow={1} />
            <SmallIconButton color='secondary' onClick={onDelete} IconComponent={Delete} tooltip={deleteTooltipTitle} />
        </Box>
    );
};

export default ActionButtons;
